import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { QueueDrawer, QueueIndex } from 'components/queue';
import { PropertyUW } from 'components/underwrite/acquisition/propertyUnderwrite';
import { AuctionUW } from 'components/underwrite/acquisition/auctionUnderwrite';
import { userRoleAuctionUnderwriteSelector } from 'store/selectors';
import { AuthorizedRoute, RouteWithTitle } from 'routes';
import { Constants } from 'utilities/constants'
import { Import } from 'components/underwrite/acquisition/import';

const Underwrite = ({ classes, location, match,
  hasAuctionUnderwriteRole, selectedTxnOpp
}) => {
  const getPropertyUWTitle = useCallback(() => {
    let title = Constants.RouteTitles.UNDERWRITE_PROPERTY;
    const pathArr = location.pathname.split('/');
    const oppId = pathArr.pop();
    if (Number.isInteger(parseInt(oppId))) {
      title = title + ' ' + oppId;
    }
    return title;
  }, [location.pathname]);

  return (
    <>
      <Switch>
        <AuthorizedRoute path={`${Constants.Routes.UNDERWRITE_AUCTION}/:id`} title={Constants.RouteTitles.UNDERWRITE_AUCTION} isAuthorized={hasAuctionUnderwriteRole}
          render={() => {
            return (
              <AuctionUW />
            )
          }}
        />
        <RouteWithTitle path={`${Constants.Routes.UNDERWRITE_PROPERTY}/:id`} title={getPropertyUWTitle()}
          render={() => {
            return (
              <PropertyUW />
            )
          }}
        />
        <RouteWithTitle path={Constants.Routes.UNDERWRITE_IMPORT} title={Constants.RouteTitles.UNDERWRITE_IMPORT} component={Import} />
        <RouteWithTitle
          path={match.url}
          title={selectedTxnOpp ? '' : Constants.RouteTitles.UNDERWRITE}
          render={() => { // Redirect to any previous state saved in our Redux store
            if (selectedTxnOpp) {
              const route = Constants.Routes.UNDERWRITE_PROPERTY;
              return <Redirect to={`${route}/${selectedTxnOpp.id}`} />
            } else {
              return (
                <QueueIndex />
              )
            }
          }}
          exact
        />
        {location.pathname !== Constants.Routes.CHANNEL_WORKFLOW &&
          <Route
            render={() => { // This will handle bad routes, send it back to index
              return <Redirect to={match.url} />;
            }}
          />
        }
      </Switch>
      <QueueDrawer />
    </>
  );
}
const mapStateToProps = state => ({
  selectedTxnOpp: state.propertyUWState.propertyUWClientTxnOpp,
  hasAuctionUnderwriteRole: userRoleAuctionUnderwriteSelector(state),
});

const styles = theme => ({
  splitPane: {
    paddingLeft: '50px'
  },
  container: {
    display: 'flex',
    position: 'relative',
    height: '100%',
  },
  charmContainer: {
    gridArea: 'charm',
    display: 'flex',
    backgroundColor: '#464646' //'#8c8c8c', '#6F6F6F',
  },
  outletContainer: {
    height: '100%',
    width: '100%',
    display: 'flex'
  },
  loadingOverlay: {
    width: '100%',
    display: 'flex'
  },
  loadingText: {
    color: theme.palette.primary.contrastText
  }
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(Underwrite);